import React, { useCallback, useEffect, useState } from 'react';
import './Carousel.scss';
import { TabText } from '../TabMenuItem/TabMenuItem';
import { useSwipe } from '../../hooks/gestures/swipeGestures';

export interface CarouselItem {
  node: React.ReactNode;
  id: TabText;
}

interface CarouselProps {
  items: CarouselItem[];
  current: TabText;
  setCurrent: (item: CarouselItem) => void;
}

const Carousel = ({ items, current, setCurrent }: CarouselProps) => {
  const [width, setWidth] = useState<number>(0);
  const activeIndex = items.findIndex((item) => item.id === current);
  const carouselRef = React.useRef<HTMLDivElement>(null);

  const previousItem = items[Math.max(activeIndex - 1, 0)];
  const nextItem = items[Math.min(activeIndex + 1, items.length - 1)];
  const onSwipeLeft = () => setCurrent(nextItem);
  const onSwipeRight = () => setCurrent(previousItem);

  useSwipe({ onSwipeLeft, onSwipeRight });

  const resizeCallback = useCallback(() => {
    if (!carouselRef.current) return;
    setWidth(carouselRef.current?.clientWidth);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', resizeCallback);
    return () => {
      window.removeEventListener('resize', resizeCallback);
    };
  }, [resizeCallback]);

  useEffect(() => {
    if (!carouselRef.current) return;
    setWidth(carouselRef.current.clientWidth);
  }, [carouselRef]);

  return (
    <div ref={carouselRef} className={'carousel-selector'}>
      {items.map((item, i) => {
        const itemPosition = i * width;
        const itemOffset = activeIndex * width * 2;
        const translate = itemPosition - itemOffset;
        return (
          <div
            key={i}
            style={{ transform: `translateX(${translate}px)` }}
            className={`carousel-selector__item ${current === item.id ? 'show' : ''}`}
          >
            {item.node}
          </div>
        );
      })}
    </div>
  );
};
export default Carousel;
